import { getLegend, getTooltip, getXaxis, getYaxis } from "../tools";

// const Aecharts = () => import('@/components/Aecharts');

const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'BeLine',
  props: {
    data: {
      type: Array,
      default: () => [
        { id: 1, name: '栏目一', value: [55, 43, 44, 32, 54, 31, 56, 23, 53, 12, 11, 21], color: '' },
        // { id: 2, label: '栏目二', value: [32, 9, 22, 32, 54, 21, 23, 32, 32, 56, 77, 55], color: '' },
        // { id: 3, label: '栏目三', value: [67, 6, 44, 13, 54, 12, 32, 11, 32, 56, 32, 32], color: '' },
        // { id: 4, label: '栏目四', value: [70, 32, 55, 42, 58, 12, 13, 42, 53, 56, 77, 54], color: '' },
        // { id: 14, label: '栏目五', value: [21, 81, 78, 87, 55, 12, 13, 41, 53, 56, 89, 65], color: '' },
        // { id: 15, label: '栏目六', value: [67, 31, 44, 13, 53, 12, 55, 23, 53, 56, 16, 76], color: '' },
      ]
    },
    type: { type: String, default: () => 'line' },
    colors: { type: Array, default: () => ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'] },
    smooth: { type: Boolean, default: () => true },
    xAxis: { type: Array, default: () => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] },
    showLegend: { type: Boolean, default: () => false },
    showTooltip: { type: Boolean, default: () => true },
    delay: { type: Number, default: () => 400 },
    backgroundColor: { type: String, default: () => '' },
  },
  data() {
    return {
      option: {},
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.create();
      }
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const { data } = this;
      const series = data && data.length > 0 && data.map((a, b) => ({
        data: a.value,
        type: a.type ? a.type : this.type,
        smooth: false, // 圆滑折线角度
        areaStyle: { // 区域填充样式
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(58,132,255, 0.5)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },
        animationDelay: c => c * b * 100,
        ...a,
      }));
      this.option = {
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series,
      };
    },
  },
  render() {
    return <Aecharts option={this.option} delay={this.delay} />
  }
}